import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity, useLang } from '@shapeable/ui';
import { useSite } from '../../hooks/use-site';
import { MetricValue } from '../elements/metric-value';
import { CONTENT_BACKGROUND, OCEAN_BLUE } from '../../theme';
import { EntityTotalCircleTrailBarChart } from '../entities/entity-total-circle-trail-bar-chart';
import { MetricLayout } from '../entities/metric-layout';

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const ValueStyles = breakpoints({
  base: css`
    
  `,
});

const ChartStyles = breakpoints({
  base: css`
    width: 100%;
    margin-top: ${theme.UNIT(4)};
  `,
});

const TextBubbleStyles = breakpoints({
  base: css`
    cursor: pointer;
    color: ${theme.COLOR('dark')};
    background: ${theme.COLOR('white')};
    box-sizing: border-box;
    border: 2px solid ${theme.COLOR('dark')};
    transition: 0s;
    &:hover {
      color: ${OCEAN_BLUE};
      border-color: ${OCEAN_BLUE};
    }
  `,
});



// -------- Components -------->

const My = {
  Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
  Value: styled(MetricValue)`${ValueStyles}`,
  Chart: styled(EntityTotalCircleTrailBarChart)`${ChartStyles}`,
};

export const BlockLayoutAreaProtectedByCountryChart: BlockLayoutComponent = (props) => {
  const { className, children } = props;
  const entity = useEntity(props.entity);
  const { metrics } = useSite();
  const { totalProtected, topProtectedByCountry = [] } = metrics;
  const t = useLang();

  const topProtectedByCountryWithTotals = topProtectedByCountry.filter((item) => item.total > 0);

  return (
    <My.Container showContent entity={entity} className={className}>
      <My.Value suffix={t('ha protected')} value={totalProtected} />
      <My.Chart
        color={OCEAN_BLUE}
        backgroundColor={CONTENT_BACKGROUND} 
        items={topProtectedByCountryWithTotals} 
      />

      {children}
    </My.Container>
  )
};